import RequestLocation from "./RequestLocation"
import ShippingOrderSegment, { IGetShippingOrderSegment } from "./ShippingOrderSegment"
import ShippingOrderTransportBase, { IGetShippingOrderTransportBaseDto, IInitShippingOrderTransportBase } from "./ShippingOrderTransportBase"

export interface IGetShippingOrderTransportDto extends IGetShippingOrderTransportBaseDto {
    segments: IGetShippingOrderSegment[]
}

interface IInitShippingOrderTransport extends IInitShippingOrderTransportBase {
    dto: IGetShippingOrderTransportDto
    locations: RequestLocation[]
}

export default class ShippingOrderTransport extends ShippingOrderTransportBase {
    segments: ShippingOrderSegment[]
    departureLocation?: RequestLocation
    arrivalLocation?: RequestLocation

    constructor(params: IInitShippingOrderTransport) {
        super(params)

        const {
            dto,
            locations,
        } = params

        this.segments = dto.segments.map(segment => new ShippingOrderSegment(segment, {
            departureLocation: locations.find(location => location.id === segment.departureLocationId),
            arrivalLocation: locations.find(location => location.id === segment.arrivalLocationId),
        }))
    }

    get areAllSegmentsComplete(): boolean {
        return this.segments.every(segment => segment.isCompleted)
    }
}
